import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, TextField, Autocomplete, Button, CircularProgress } from '@mui/material';
import { fetchClients } from '../../data/slices/clientStore';
import { Description as InvoiceIcon, PersonSearch as SearchIcon } from '@mui/icons-material';
import { COLORS } from '../../settings/themeSettings';

const FacturationNouvelle = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { clients, fetchStatus } = useSelector((state) => state.clients);

    const [searchTerm, setSearchTerm] = useState('');
    const [selectedClient, setSelectedClient] = useState(null);

    // Charger tous les clients au montage de la page
    useEffect(() => {
        console.log('[FacturationNouvelle] Chargement initial de tous les clients');
        dispatch(fetchClients({ page: 1, limit: 100 })); // Charger les 100 premiers clients
    }, [dispatch]);

    // Charger les clients lors de la recherche (avec debounce)
    useEffect(() => {
        if (!searchTerm) return; // Ne pas rechercher si vide (on garde la liste initiale)

        const timer = setTimeout(() => {
            console.log('[FacturationNouvelle] Recherche clients avec terme:', searchTerm);
            dispatch(fetchClients({ page: 1, nail: searchTerm, criteria: 'nom', limit: 50 }));
        }, 500);

        return () => clearTimeout(timer);
    }, [searchTerm, dispatch]);

    // Log pour suivre les résultats
    useEffect(() => {
        console.log('[FacturationNouvelle] Statut de récupération:', fetchStatus);
        console.log('[FacturationNouvelle] Nombre de clients récupérés:', clients?.length || 0);
        if (clients && clients.length > 0) {
            console.log('[FacturationNouvelle] Premiers clients:', clients.slice(0, 3));
        }
    }, [clients, fetchStatus]);

    const handleClientSelect = (event, value) => {
        if (value) {
            navigate(`/billeterie/factures/nouveau/${value.id}`);
        }
    };

    return (
        <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '80vh' }}>
            <Paper sx={{ p: 4, width: '100%', maxWidth: 600, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <InvoiceIcon sx={{ fontSize: 40, color: COLORS.secondary }} />
                    <Typography variant="h4" component="h1" color="textPrimary">
                        Nouvelle Facture
                    </Typography>
                </Box>

                <Typography variant="body1" color="textSecondary" align="center">
                    {clients && clients.length > 0
                        ? `${clients.length} client(s) disponible(s). Tapez pour filtrer ou sélectionnez directement.`
                        : 'Chargement des clients...'}
                </Typography>

                <Autocomplete
                    fullWidth
                    options={clients || []}
                    getOptionLabel={(option) => {
                        const nom = option.nom || '';
                        const prenom = option.prenom || '';
                        return `${nom} ${prenom} (${option.telephone || 'N/A'})`.trim();
                    }}
                    loading={fetchStatus === 'loading'}
                    onInputChange={(event, newInputValue) => {
                        setSearchTerm(newInputValue);
                    }}
                    onChange={handleClientSelect}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Rechercher ou sélectionner un client"
                            placeholder="Tapez un nom, prénom ou numéro de téléphone..."
                            variant="outlined"
                            InputProps={{
                                ...params.InputProps,
                                startAdornment: <SearchIcon color="action" sx={{ mr: 1 }} />,
                                endAdornment: (
                                    <React.Fragment>
                                        {fetchStatus === 'loading' ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                        />
                    )}
                    isOptionEqualToValue={(option, val) => (option?.id && val?.id ? option.id === val.id : option === val)}
                    renderOption={(props, option, { index }) => {
                        const { key, ...otherProps } = props;
                        const uniqueKey = option.id || option._id || (option.code ? `client-${option.code}-${index}` : `client-idx-${index}`);
                        return (
                            <li key={uniqueKey} {...otherProps}>
                                <Box>
                                    <Typography variant="subtitle1" fontWeight="bold">
                                        {option.nom} {option.prenom}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        {option.telephone} - {option.email}
                                    </Typography>
                                </Box>
                            </li>
                        );
                    }}
                />

                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => navigate(-1)}
                    >
                        FERMER / Retour
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => navigate('/billeterie/factures/nouveau/COMPTANT')}
                    >
                        Créer Facture Comptant
                    </Button>
                </Box>

            </Paper>
        </Box>
    );
};

export default FacturationNouvelle;
